// action due dates are saved as 00:00 UTC, so convert to the equivalent
// of 00:00 local time when comparing the due date to 'today' or 'now'
export default function offsetLocalTimezone(localTime) {
  const localOffset = new Date().getTimezoneOffset();
  const offsetTime = 60 * 1000 * localOffset;

  return new Date(localTime + offsetTime).getTime();
}
